import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import {
  compose,
} from '../../../services/utilityFunctions';
import withCSRF from '../../../commonComponents/withCSRF';
import CertificateByLetter from './icons/CertificateByLetter';
import CertificateByEmail from './icons/CertificateByEmail';
import CertificateByShare from './icons/CertificateByShare';

function CertificateDisplay({ t, type, price }) {
  let iconButton;
  let message;
  let info;
  if (type === 'share') {
    iconButton = <CertificateByShare />;
    message = t('certificate_shareOnSocial');
    info = (
      <div className="share-icons">
        <div className="share-icon">
          <i className="socicon-facebook" />
        </div>
        <div className="share-icon">
          <i className="socicon-linkedin" />
        </div>
        <div className="share-icon">
          <i className="socicon-twitter" />
        </div>
      </div>);
  } else if (type === 'email') {
    iconButton = <CertificateByEmail />;
    message = t('certificate_byEmail_free');
    info = <span>{price}</span>;
  } else {
    iconButton = <CertificateByLetter />;
    message = t('certificate_byLetterNew');
    info = <span>{price}</span>;
  }
  return (
    <div className="m-portlet m-portlet--rounded m-portlet--rounded-force certificate-button">
      <div>
        {iconButton}
      </div>
      <div className="certificate-button-message">
        {message}
      </div>
      <div className="certificate-button-info">
        {info}
      </div>
    </div>
  );
}

CertificateDisplay.propTypes = {
  t: PropTypes.func.isRequired,
  type: PropTypes.string,
  price: PropTypes.string,
};

CertificateDisplay.defaultProps = {
  type: 'email',
  price: '',
};

export default compose(
  translate,
  withCSRF,
)(CertificateDisplay);
